/**
 * Removes unwanted AI suggestions and prompts from the end of reports
 * ULTRA-CONSERVATIVE: Only removes content that is CLEARLY an AI question/suggestion
 * @param {string} report - The raw AI-generated report
 * @returns {string} - Cleaned report without unwanted suggestions
 */
export function cleanAIReport(report) {
  if (!report || typeof report !== 'string') {
    return report || '';
  }

  let cleaned = report.trim();

  // ONLY remove content after "---" separator that CLEARLY starts with AI suggestion patterns
  // This is the most common pattern - AI adds suggestions after a separator
  const separatorPattern = /(\n---+\s*\n)(.*)$/s;
  const separatorMatch = cleaned.match(separatorPattern);
  
  if (separatorMatch) {
    const separator = separatorMatch[1];
    const contentAfterSeparator = separatorMatch[2].trim();
    
    // ONLY check for VERY CLEAR AI suggestion/question patterns that START the content
    // These must be obvious AI questions, not legitimate report content
    const clearAISuggestionPatterns = [
      /^Do you want me to refine any of these sections/i,
      /^Do you want me to refine/i,
      /^Would you like me to refine/i,
      /^Would you like me to/i,
      /^Can I help you refine/i,
      /^Can I help you/i,
      /^Shall I refine/i,
      /^Shall I/i,
      /^Let me know if you'd like/i,
      /^Let me know if/i,
      /^Feel free to let me know/i,
      /^Feel free to/i,
      /^If you'd like me to/i,
      /^If you'd like/i,
      /^If you need me to/i,
      /^If you need/i,
      /^or perhaps generate content for a specific format/i,
      /^or perhaps/i,
      /^Maybe I can/i,
      /^I can help you refine/i,
      /^I can help you/i,
      /^I can refine any of these sections/i,
      /^I can refine/i,
    ];
    
    // Check if content STARTS with a clear AI suggestion pattern
    const hasClearSuggestion = clearAISuggestionPatterns.some(pattern => {
      return pattern.test(contentAfterSeparator);
    });
    
    if (hasClearSuggestion) {
      // Only remove if it's clearly an AI suggestion
      cleaned = cleaned.replace(separatorPattern, '');
    }
  }

  // Remove trailing --- separators (but only if they're truly at the end with nothing after)
  cleaned = cleaned.replace(/\n---+\s*$/m, '');
  
  // Remove any trailing newlines and whitespace
  cleaned = cleaned.trim();

  return cleaned;
}
